export default __webpack_public_path__ + "assets/images/1.5b0907.avif";